/* /pricing: plans are data, so paid plans can be added later without touching the page.
   A plan: {id, name, code, color, price, per, blurb, features:[…], cta:{label, href}, soon:boolean} */
export var PLANS = [
  {
    id: "early",
    name: "Early access",
    code: "NOW",
    color: "var(--good)",
    price: "Free",
    per: "while in early access",
    blurb: "The whole app, for you and your business, while we test it together.",
    features: [
      "Unlimited cards, card types, folders and links",
      "Wheel, Today, Board, Calendar, Timeline and Upcoming views",
      "Reminders, snooze and repeating tasks",
      "Templates and duplicate",
      "Notes pages with photos, screenshots and PDFs",
      "Meeting cards with a notes page for each date",
      "Import from spreadsheets, contacts and calendars",
      "Work and Home card sets",
      "1 GB of file storage",
      "Nightly backup kept for 30 days, and export any time",
      "Stored privately in the EU (Ireland)"
    ],
    cta: {label: "Join the waiting list", href: "/welcome#join"}
  },
  {
    id: "later",
    name: "Paid plans",
    code: "SOON",
    color: "var(--faint)",
    price: "Later",
    per: "",
    blurb: "When Tabwheel leaves early access there will be paid plans, including one for teams sharing a workspace.",
    features: [
      "We'll tell you well before anything changes",
      "Nothing is charged without you choosing a plan",
      "You can export all your cards at any time"
    ],
    soon: true
  }
];

function esc(s){ return String(s == null ? "" : s).replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); }

export function renderPlans(host, plans){
  host.innerHTML = plans.map(function(p){
    return '<article class="ic plan' + (p.soon ? " soon" : "") + '" style="--tc:' + esc(p.color) + '" aria-labelledby="plan-' + esc(p.id) + '">' +
      '<span class="ic-tab"><b>' + esc(p.code) + '</b> ' + esc(p.name) + '</span>' +
      '<div class="ic-head"><h2 id="plan-' + esc(p.id) + '" style="font-size:22px">' + esc(p.name) + '</h2></div>' +
      '<p class="price">' + esc(p.price) + (p.per ? ' <small>' + esc(p.per) + '</small>' : "") + '</p>' +
      '<p class="blurb">' + esc(p.blurb) + '</p>' +
      '<ul>' + p.features.map(function(f){ return '<li>' + esc(f) + '</li>'; }).join("") + '</ul>' +
      (p.cta ? '<a class="btn primary" href="' + esc(p.cta.href) + '">' + esc(p.cta.label) + ' <span class="arrow" aria-hidden="true">&rarr;</span></a>' : "") +
    '</article>';
  }).join("");
}

var host = document.getElementById("plans");
if(host) renderPlans(host, PLANS);
